if (!customElements.get('marquee-container')) {
  customElements.define(
    'marquee-container',
    class MarqueeContainer extends HTMLElement {
      connectedCallback() {
        this.setNodeSelectors();
        this.setEventListeners();
        this.setCloneState();
      }

      /**
       * Sets the node selectors.
       */
      setNodeSelectors() {
        this.nodeSelectors = {
          containers: this.querySelectorAll('[js-marquee-container="container"]'),
        };
      }

      /**
       * Sets the event listeners.
       */
      setEventListeners() {
        window.addEventListener(
          'resize',
          debounce(() => this.setCloneState())
        );
      }

      /**
       * Returns the total width of all container content.
       * @returns {Number}
       */
      getTotalContainerWidth() {
        return [...this.nodeSelectors.containers].reduce((accumulator, current) => {
          accumulator += current.offsetWidth;

          return accumulator;
        }, 0);
      }

      /**
       * Clones containers if there isn't enough content to fill the parent container.
       */
      setCloneState() {
        const totalContainerWidth = this.getTotalContainerWidth();
        const difference = this.offsetWidth - totalContainerWidth;

        if (difference <= 0) {
          return;
        }

        for (let i = 0; i < Math.ceil(difference / totalContainerWidth) + 1; i++) {
          this.cloneContainers();
        }
      }

      /**
       * Clones the container content.
       */
      cloneContainers() {
        this.appendChild([...this.nodeSelectors.containers][0].cloneNode(true));
        this.setNodeSelectors();

        [...this.nodeSelectors.containers].forEach((container) => {
          container.classList.add('paused');

          setTimeout(() => {
            container.classList.remove('paused');
          }, 0);
        });
      }
    }
  );
}
